import type { MatchModelBase, BasketballMatchModel } from '@nf/types/odds';
import { matchSome } from '@nf/utils-common/fpw/monadic';

import { PeriodScoresBase } from './period-scores.base';
import { DefaultPeriodScores } from './period-scores-strategies/default-period-scores';
import { BasketballPeriodScores } from './period-scores-strategies/basketball-period-scores';

export class PeriodScoresFactory {
	static createPeriodScoresStrategy(match: MatchModelBase): PeriodScoresBase<MatchModelBase> {
		return matchSome(match.GameID)
			.on(
				(sport: number) => [2, 993].includes(sport), 
				() => new BasketballPeriodScores(match as BasketballMatchModel)
			)
			.otherwise(() => new DefaultPeriodScores(match));
	}
}